import DynamicForm from '@camiloruiiz/dynamic-form';

import '@camiloruiiz/dynamic-form/dist/style.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(DynamicForm);
});
